let timer
export const refreshAffirm = () => {
    if (timer) clearTimeout(timer)

    timer = setTimeout(() => {
        if (window.affirm) window.affirm.ui.ready(() => window.affirm.ui.refresh())
    }, 500)
}
